import { render } from "./DeleteEmployee.vue?vue&type=template&id=25274c18"
import script from "./DeleteEmployee.vue?vue&type=script&lang=js"
export * from "./DeleteEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__